function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.304 48.038c-22.067 1.667-27.358 20.678-20.967 40.747 6.391 20.07 31.16 12.955 44.493 15.89 13.334 2.935 39.027-1.007 39.027-18.562s-13.012-7.851-18.012-23.797c-5-15.946-22.474-15.946-44.541-14.278z",
  fill: "#FFF5DC"
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127.401,
  cy: 61.268,
  rx: 2.65,
  ry: 2.647,
  fill: "#FF5A17"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124.701,
  cy: 50.169,
  rx: 5.299,
  ry: 5.294,
  fill: "#FDB913"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.678 110.156a.958.958 0 010-1.355l3.094-3.091a.957.957 0 011.354 0l3.094 3.091a.958.958 0 010 1.355l-3.094 3.091a.957.957 0 01-1.354 0l-3.094-3.091z",
  fill: "#FDB913"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.203 26.75a.794.794 0 011.464-.019l1.604 3.686 3.41 1.881a.794.794 0 01.001 1.39l-3.411 1.89-1.458 3.633a.794.794 0 01-1.453.048l-1.647-3.422-3.584-1.993a.794.794 0 01-.006-1.384l3.59-2.043 1.49-3.668zM123.361 92.228a.794.794 0 011.464-.018l1.026 2.357 2.264 1.249a.794.794 0 01.002 1.39l-2.266 1.255-.936 2.331a.794.794 0 01-1.452.049l-1.052-2.185-2.402-1.335a.794.794 0 01-.006-1.384l2.408-1.37.95-2.34z",
  fill: "#F58220"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FDB913",
  d: "M49.401 47.131h7.313v10.328h-7.313z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M73.137 78.71c0-.636.515-1.151 1.151-1.151h32.465c.636 0 1.151.515 1.151 1.151v25.828H73.137V78.71z",
  fill: "url(#marketplace-illustration_svg__paint0_linear_164_13940)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M87.303 77.559h7.313v9.105h-7.313v-9.105z",
  fill: "url(#marketplace-illustration_svg__paint1_linear_164_13940)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M35.026 67.66c0-.745.604-1.35 1.35-1.35h33.866c.745 0 1.349.605 1.349 1.35v35.709H35.026v-35.71z",
  fill: "url(#marketplace-illustration_svg__paint2_linear_164_13940)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M36.363 47.005c0-.745.604-1.349 1.35-1.349h26.553c.745 0 1.349.604 1.349 1.35v19.306H36.363V47.005z",
  fill: "url(#marketplace-illustration_svg__paint3_linear_164_13940)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M47.187 45.656h7.312V55.69h-7.313V45.656z",
  fill: "url(#marketplace-illustration_svg__paint4_linear_164_13940)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#marketplace-illustration_svg__paint5_linear_164_13940)",
  d: "M49.651 65.975h7.313v12.14h-7.313z"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 97.462,
  cy: 45.346,
  rx: 20.169,
  ry: 20.346,
  fill: "#F6694C"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M90.47 45.98l4.096 4.75 9.887-10.755",
  stroke: "#fff",
  strokeWidth: 4.047,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M32.043 103.144c-1.602 0-2.937-1.347-2.937-2.964V47.23c0-3.233-2.67-5.927-5.874-5.927h-7.343c-1.602 0-2.937 1.347-2.937 2.964s1.335 2.964 2.937 2.964h7.343v54.566c0 4.042 3.204 7.41 7.343 7.41h78.9c1.602 0 2.937-1.347 2.937-2.964s-1.335-2.964-2.937-2.964H32.043v-.135z",
  fill: "url(#marketplace-illustration_svg__paint6_linear_164_13940)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.897 41.303v5.928h-5.874c-1.602 0-2.937-1.347-2.937-2.964.133-1.752 1.335-2.964 2.937-2.964h5.874z",
  fill: "#F6694C"
});

var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 42.99,
  cy: 105.435,
  rx: 9.479,
  ry: 9.566,
  fill: "url(#marketplace-illustration_svg__paint7_linear_164_13940)"
});

var _ref18 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 42.991,
  cy: 105.434,
  rx: 5.073,
  ry: 5.12,
  fill: "url(#marketplace-illustration_svg__paint8_linear_164_13940)"
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 88.248,
  cy: 105.435,
  rx: 9.479,
  ry: 9.566,
  fill: "url(#marketplace-illustration_svg__paint9_linear_164_13940)"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 88.249,
  cy: 105.434,
  rx: 5.073,
  ry: 5.12,
  fill: "url(#marketplace-illustration_svg__paint10_linear_164_13940)"
});

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint0_linear_164_13940",
  x1: 70.962,
  y1: 94.528,
  x2: 89.17,
  y2: 118.668,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint1_linear_164_13940",
  x1: 87.515,
  y1: 83.462,
  x2: 93.234,
  y2: 88.298,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint2_linear_164_13940",
  x1: 32.739,
  y1: 89.619,
  x2: 58.748,
  y2: 116.021,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint3_linear_164_13940",
  x1: 34.534,
  y1: 58.648,
  x2: 48.063,
  y2: 78.359,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint4_linear_164_13940",
  x1: 47.399,
  y1: 52.161,
  x2: 53.572,
  y2: 56.898,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint5_linear_164_13940",
  x1: 49.864,
  y1: 73.846,
  x2: 56.859,
  y2: 78.282,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint6_linear_164_13940",
  x1: 6.731,
  y1: 84.012,
  x2: 50.649,
  y2: 150.193,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint7_linear_164_13940",
  x1: 32.326,
  y1: 107.902,
  x2: 45.752,
  y2: 121.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint8_linear_164_13940",
  x1: 38.212,
  y1: 106.953,
  x2: 44.729,
  y2: 113.751,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint9_linear_164_13940",
  x1: 77.584,
  y1: 107.902,
  x2: 91.01,
  y2: 121.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEB31A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE852A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "marketplace-illustration_svg__paint10_linear_164_13940",
  x1: 83.47,
  y1: 106.953,
  x2: 89.987,
  y2: 113.751,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF8C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD98A"
})));

function SvgMarketplaceIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

export default SvgMarketplaceIllustration;